/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 959px) and (min-width: 480px) {
    flex-shrink: 0;
  }
`;

const Switch = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 63px;
  height: 30px;
  padding: 4px;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  text-transform: uppercase;
  color: ${({ theme }) => theme.foreground};
  text-align: center;
  background-color: ${props => props.theme.mainHighlight};
  border-radius: 30px;
  cursor: pointer;

  ${props =>
    props.compactMode &&
    css`
      width: 30px;
      height: 20px;
      padding: 2px;
    `};
`;

const Toggle = styled.div`
  position: absolute;
  top: 5px;
  left: 0;
  transform: translateX(4px);
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.foreground};
  border-radius: 50%;
  transition: transform 0.3s ease, background-color 0.3s ease-in-out;
  z-index: 10;

  ${props =>
    props.isActive &&
    css`
      transform: translateX(calc(200% - 4px));
      background-color: ${props => props.theme.accent};
    `} ${props =>
    props.compactMode &&
    css`
      width: 10px;
      height: 10px;
    `};
`;

const Text = styled.div`
  flex-grow: 1;
  text-align: center;
  padding-left: 20px;

  ${props =>
    props.isActive &&
    css`
      padding-left: 0;
      padding-right: 20px;
    `};
`;

type Props = {
  value: boolean,
  onChange: (value: boolean) => void
};

export default function ToggleTool({
  compactMode,
  value,
  onChange,
  title
}: Props) {
  return (
    <Container title={title}>
      <Switch compactMode={compactMode} onClick={() => onChange(!value)}>
        <Toggle compactMode={compactMode} isActive={value} />
        {!compactMode && <Text isActive={value}>{value ? "On" : "Off"}</Text>}
      </Switch>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToggleTool.js